import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.unshare-shared-accounts', {
        url: '/remove-shared-accounts',
        params: {accounts: []},
        component: 'companyUserDirectoriesManageUserUnshareSharedAccounts',
        resolve: {
            accounts,
        },
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/unshare-shared-accounts/unshare-shared-accounts.state.js